import React, { useEffect, useState } from "react";
import { HeaderComponent } from "../Config/header";
import { FooterComponent } from "../Config/footer";
import { Input } from "antd";
import { API_BASE_URL } from "../Config/Config";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [storedUserData, setStoredUserData] = useState([]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      try {
        const parsedUserDetails = JSON.parse(userDataString);
        setStoredUserData(parsedUserDetails);
      } catch (error) {
        console.error("Error parsing userDetails:", error);
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updatedForm = { ...prev, [name]: value };
      // Validation logic for passwords
      if (name === "newPassword" || name === "confirmPassword") {
        if (updatedForm.newPassword.length < 4) {
          setError("New password must be at least 4 characters.");
          setIsSubmitEnabled(false);
        } else if (updatedForm.newPassword !== updatedForm.confirmPassword) {
          setError("Passwords do not match.");
          setIsSubmitEnabled(false);
        } else {
          setError("");
          setIsSubmitEnabled(true);
        }
      }

      return updatedForm;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state
    try {
      const response = await fetch(`${API_BASE_URL}user/changepwd`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          inputdata: {
            newpwd: formData.newPassword,
            SuperId: storedUserData.SuperId,
            RegId: storedUserData.RegId,
            oldpwd: formData.oldPassword,
            username: storedUserData.Badge,
          },
        }),
      });
      const data = await response.json();

      if (data.Status) {
        setLoading(false);
        setErrorMessage("");
        window.alert("Password changed successfully!");
        sessionStorage.removeItem("userData");
        navigate("/");
      } else {
        setLoading(false);
        setErrorMessage(data.Message); // Set error message from the service
      }
    } catch (err) {
      console.error("Error during password change:", err);
      setLoading(false);
      setErrorMessage("An unexpected error occurred. Please try again."); // Generic error
    }
  };
  return (
    <>
      <HeaderComponent></HeaderComponent>
      <div className="bg-body d-flex flex-center rounded-4 p-5 mt-5 mx-5">
        <div className="card">
          <div className="card-body">
            <form className="form w-100" onSubmit={handleSubmit}>
              <div className="text-center mb-11">
                <h1 className="text-dark fw-bolder mb-3">Change Password</h1>
              </div>
              <div className="fv-row mb-3 text-start">
                <label className="text-gray-600 mb-2">Old Password</label>
                <Input.Password
                  name="oldPassword"
                  placeholder="Old Password"
                  value={formData.oldPassword}
                  onChange={handleChange}
                />
              </div>
              <div className="fv-row mb-3 text-start">
                <label className="text-gray-600 mb-2">New Password</label>
                <Input.Password
                  name="newPassword"
                  placeholder="New Password"
                  value={formData.newPassword}
                  onChange={handleChange}
                />
              </div>
              <div className="fv-row mb-8 text-start">
                <label className="text-gray-600 mb-2">
                  Confirm New Password
                </label>
                <Input
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>
              {error && (
                <p className="text-start text-danger fw-bold">{error}</p>
              )}
              <div className="d-grid mb-2">
                <button
                  type="submit"
                  id="kt_sign_in_submit"
                  className="btn btn-primary"
                  disabled={!isSubmitEnabled || loading} // Disable during loading or validation failure
                >
                  {loading ? "Please wait..." : "Submit"}
                </button>
              </div>
              {errorMessage && (
                <p className="text-start text-danger fw-bold">
                  {errorMessage === " old psw wrong"
                    ? "*Incorrect Old Password"
                    : errorMessage}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
      <FooterComponent></FooterComponent>
    </>
  );
};

export default ChangePassword;
